module.exports = __webpack_public_path__ + "static/media/arrow--left--dark-gray.baac7cd4.svg";